/**
 * @param {Object} obj object
 * @returns {boolean} is a string?
 */
function isAString(obj) {
  return obj.constructor === String;
}

/**
 * @param {string} str string to proper case
 * @returns {string} proper cased string
 */
function upperCaseFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * @param {string} str string
 * @returns {string} proper cased string
 */
function lowerCaseAllButFirst(str) {
  return str.charAt(0) + str.slice(1).toLowerCase();
}

/**
 * @param {Object} context undefined
 * @param {Object} fn undefined
 * @param {Object} args undefined
 * @returns {void}
 */
function runOnce(context = this, fn, args) {
  fn.apply(context, args);
}

// It amazes me that this function is necessary
/**
 * @param {Object} el undefined
 * @returns {boolean} is $?
 */
function isJqueryEl(el) {
  return 'jquery' in Object(el);
}

/**
 * @param {Object} el undefined
 * @returns {boolean} is array
 */
function isPlainArray(el) {
  return el && el.constructor === Array && !isJqueryEl(el);
}

/**
 * @param {Object} el undefined
 * @returns {boolean} is a list of nodes
 */
function isNodeList(el) {
  return el && el.constructor === NodeList;
}

/**
 * @param {string} key key string
 * @returns {string} proper cased string
 * @desc e.g. ' Blah Blah YAda' -> 'blahblahyada'
 */
function lowerTrimString(key) {
  return key.replace(/ /g, '').toLowerCase();
}

/**
 * @param {Object} obj undefined
 * @returns {boolean} is a list of nodes
 * @desc turns all object keys into lowercase, trimmed keys.  You're welcome.
 */
function lowerTrimObjectKeys(obj) {
  return Object.assign({}, ...Object.keys(obj).map(key => ({
    [lowerTrimString(key)]: obj[key]
  })));
}

/**
 * @param {Object} array1 undefined
 * @param {Object} array2 undefined
 * @returns {boolean} is a list of nodes
 * @desc give back an array of the non-matches.  You're welcome.
 */
function arrayDiff(array1, array2) {
  const diffIndexes = [];
  return array2.filter(i => {
    if (array1.indexOf(i) < 0) {
      diffIndexes.push(array2.indexOf(i));
      return true;
    }
    return false;
  });
}

/**
   * @param {Object} arr1 array 1
   * @param {Object} arr2 array 2
   * @returns {boolean} are all in the other array?
 */
function areAllValuesInAnotherArray(arr1, arr2) {
  return arr1.every(val => arr2.includes(val));
}

/**
   * @param {any} val value
   * @param {Object} arr array
   * @returns {boolean} is value in array?
 */
function isValueInArray(val, arr) {
  return arr.indexOf(val) !== -1;
}

/**
   * @param {Object} arr array
   * @returns {Object} array
 */
function removeDuplicatesFromArray(arr) {
  return Array.from(new Set(arr));
}

/**
   * @param {Object} obj object to convert
   * @returns {Object} new array
 */
function convertObjectToArray(obj) {
  return Object.keys(obj).map(key => obj[key]);
}

/**
   * @param {string} val array 1
   * @param {string} str array 2
   * @returns {boolean} is the value in the string
 */
function isValueInString(val, str) {
  return str.indexOf(val) !== -1;
}

/**
   * @param {Object} obj undefined
   * @param {string} defaultValue default
   * @returns {Object} cleared obj
 */
function clearObjectValues(obj, defaultValue = '') {
  const newObj = {};
  // eslint-disable-next-line no-return-assign
  Object.keys(obj).forEach(key => newObj[key] = defaultValue);
  return newObj;
}

/**
   * @param {string} newTitle undefined
   * @param {number} duration undefined
   * @returns {boolean} are all in the other array?
 */
function changePageTitle(newTitle, duration = 1000) {
  const originalPageTitle = document.title;
  document.title = newTitle;
  // eslint-disable-next-line no-return-assign
  setTimeout(() => document.title = originalPageTitle, duration);
}

/**
 * Takes a data object and returns it as a flat object with all of the key names dot notated.
 *
 * Example:
 *    Input:
 *      { applicantInfoList: [ { addressLines: [ "777", "Faith Rd" ] } ] }
 *
 *    Output:
 *      { applicantInfoList.0.addressLines.0:"777", applicantInfoList.0.addressLines.1:"Faith Rd" }
 *
 * @param {Object} standardDataObject undefined
 * @returns {Object} object
 */
function makeDotNotatedDataObject(standardDataObject) {
  const flatDotNotatedKeyObject = {};

  // 2023-01-04 - TODO: Come back to this. It will haunt you
  // recursively look into the enteredInput object and create an object with dot
  // notation of the property as key
  // eslint-disable-next-line wrap-iife
  (function recurse(obj, current) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        const newKey = current ? `${current}.${key}` : key;
        if (value && typeof value === 'object') {
          recurse(value, newKey); // it's a nested object, so do it again
        } else {
          flatDotNotatedKeyObject[newKey] = value; // it's not an object, so set the property
        }
      }
    }
  })(standardDataObject);
  return flatDotNotatedKeyObject;
}

/**
   * @param {number} num undefined
   * @param {string} separator undefined
   * @returns {string} number
 */
function formatNumberByThree(num, separator = ',') {
  // 100000 -> '100,000'
  // format number to insert back into DOM
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

/**
   * @param {number} num undefined
   * @returns {number} number
 */
function removeCommasFromNumber(num) {
  // '100,000' => 100000
  return parseFloat(num.toString().replace(/,/g, ''));
}

/**
   * @param {number} num undefined
   * @returns {number} number
 */
function roundUpToWholeNumber(num) {
  // 99.941 -> 100
  return Math.ceil(num);
}

/**
 * @param {number} num a number without commas
 * @returns {number} number with commas
 * This function was removed/omitted in 6.0.0, causing errors with
 * monthly payment display on info-auto-loans (CFSSCMONEY-13031).
 */
function addCommasToNumber(num) {
  // format number to insert back into DOM
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
   * @param {number} loanAmount undefined
   * @param {number} rate undefined
   * @param {number} term undefined
   * @returns {number} number
 */
function calculateMonthlyPayment(loanAmount, rate, term) {
  // check for 0 or no loan amount
  if (!loanAmount) return 0;

  // remove comma from loan amount value and parse to decimal
  const principle = removeCommasFromNumber(loanAmount);
  // format rate
  const intr = parseFloat(rate) / 1200;
  // calculate monthly payment and round up to next whole number

  let payment;

  // if intr is 0, then just divide principle to term
  if (!intr) {
    payment = roundUpToWholeNumber(principle / term);
  } else {
    // eslint-disable-next-line no-mixed-operators
    payment = roundUpToWholeNumber(principle * intr / (1 - 1 / (1 + intr) ** term));
  }

  // update view to show monthly payment
  return addCommasToNumber(payment);
}

/**
   * @param {Object} arrays undefined
   * @returns {Object} array
 */
function reduceArrayMerge(...arrays) {
  return arrays.reduce((arr1, arr2) => Array.prototype.push.apply(arr1, arr2));
}

/**
   * @param {Object} array undefined
   * @returns {Object} array
 */
function arrayValuesAreEqual(array) {
  return !!array.reduce((a, b) => a === b ? a : NaN);
}

// Sparta adds body classes to the page.
// This will return the t-shirt size of your screen from those added classes.
/**
   * @returns {string} size
 */
function getPageSize() {
  const bodyClassList = document.querySelector('body').classList;
  const small = [...bodyClassList].indexOf('small-only') > -1 && 'small';
  const medium = [...bodyClassList].indexOf('medium-only') > -1 && 'medium';
  const large = [...bodyClassList].indexOf('large') > -1 && 'large';
  return small || medium || large;
}

/**
   * @returns {Object} array
 */
function prefixen() {
  return ['webkit', 'moz', 'MS', 'o', ''];
}

// Going to come back to this. it doesn't seem like it's used...
// and it's the most useless function I've ever seen
// give it an event and this returns your browsers prefixed event names
/**
   * @param {Object} event undefined
   * @returns {Object} array
 */
function prefixedEventName(event) {
  const fakeEl = document.createElement('fakeelement');
  let eventName = event.toLowerCase();
  prefixen().some(prefix => {
    if (fakeEl.style[prefix + event] !== undefined) {
      eventName = prefix + event;
      // Are we short circuiting this after the first iteration EVERY SINGLE TIME?? WHY?
      return true; // break out of loop
      // eslint-disable-next-line no-else-return
    } else {
      return true; // break out of loop
    }
  });

  return eventName;
}

// clearly dt is a string so use something like '01/01/2018' or 'Dec 12, 2019'
/**
   * @param {string} dt undefined
   * @returns {boolean} is a weekend
 */
function isWeekend(dt = '') {
  // eslint-disable-next-line no-bitwise
  return !!~[0, 6].indexOf(new Date(dt).getDay());
}

/**
 * @param {Object} el element
 * @param {Object} options options object
 * @param {function} callback callback function
 * @returns {void}
 */
function createElementObserver(el, options, callback) {
  const mutationCallback = allmutations => {
    // since allmutations is an array, we can use array functions
    allmutations.forEach(mutationRecord => callback(mutationRecord));
  };
  const Observer = new MutationObserver(mutationCallback);
  Observer.observe(el, options);
}

// this takes a list of elements and applies a single function or list of functions each
// element of the list
// this is a bit of functional programming that simplifies your code if you're doing lots of
// transformations on elements of your list

/**
 * @param {Object} elements undefined
 * @param {Object} callbacks array of callbacks
 * @returns {Object} new array of elements
 */
function applyFunctionsToElements(elements, callbacks = []) {
  let newArr = [];
  const callbacksArray = !isPlainArray(callbacks) ? [callbacks] : callbacks;
  const applyCallbackToElements = el => callbacksArray.map(callback => callback(el))[0];
  newArr = [...elements].map(obj => applyCallbackToElements(obj));
  return newArr;
}
var index = {
  createElementObserver,
  applyFunctionsToElements,
  isAString,
  upperCaseFirst,
  lowerCaseAllButFirst,
  runOnce,
  isJqueryEl,
  isPlainArray,
  isNodeList,
  lowerTrimString,
  lowerTrimObjectKeys,
  arrayDiff,
  areAllValuesInAnotherArray,
  isValueInArray,
  removeDuplicatesFromArray,
  convertObjectToArray,
  isValueInString,
  clearObjectValues,
  changePageTitle,
  makeDotNotatedDataObject,
  formatNumberByThree,
  removeCommasFromNumber,
  roundUpToWholeNumber,
  calculateMonthlyPayment,
  reduceArrayMerge,
  arrayValuesAreEqual,
  getPageSize,
  prefixen,
  prefixedEventName,
  isWeekend
};

export { index as default };
